/** @format */
import { OtmId } from '../../../types/commonTypes.js';
import { Rule } from '../../../types/generated/common-backend.js';
import { RuleValidationResult, RuleValidationResultFor } from './ruleValidationResult.js';
import { ValidatablePlan } from './validatablePlan.js';

export class PlanValidationResult {
    validatablePlan: ValidatablePlan | null = null;
    rootValidationResult: any = null;
    moduleValidationResults: { [id: string]: any } = {};
    courseUnitValidationResults: { [id: string]: any } = {};
    customModuleAttainmentValidationResults: { [id: string]: any } = {};
    customCourseUnitAttainmentValidationResults: { [id: string]: any } = {};
    ruleValidationResults: { [parentModuleId: string]: { [ruleLocalId: string]: RuleValidationResult } } = {};
    moduleIndexes: { [id: string]: number | null } = {};
    courseUnitIndexes: { [id: string]: number | null } = {};
    customModuleAttainmentIndexes: { [id: string]: number | null } = {};
    customCourseUnitAttainmentIndexes: { [id: string]: number | null } = {};
    matchingModuleContentApprovalsByModuleId: { [id: string]: any } = {};
}

/**
 * The validation result of `rule` under `parentModuleId`, typed by the rule type. The validator stores each rule's result under its
 * `localId`, so the result found there is always of the rule's own type.
 */
export function getRuleValidationResult<R extends Rule>(
    planValidationResult: PlanValidationResult | null | undefined,
    parentModuleId: OtmId,
    rule: R,
): RuleValidationResultFor<R> | undefined {
    return planValidationResult?.ruleValidationResults?.[parentModuleId]?.[rule?.localId] as RuleValidationResultFor<R> | undefined;
}
